import { apiRequest } from './client';
import type { BlockedReport, ReportByKind, ReportKind } from '../types/reports';

/**
 * P-084 · Los cinco reportes de Reportes, uno por petición: `GET /api/dashboard/reports/:report?dateFrom&dateTo`.
 * El periodo viaja como fechas de calendario; la tienda NO se manda (N5: el alcance lo decide el servidor).
 * Resuelve a `undefined` con 204 (sin bloque financiero ni explicación), como `getOwnerOverview`.
 */
export const getReport = <K extends ReportKind>(kind: K, range: { dateFrom: string; dateTo: string }) =>
  apiRequest<ReportByKind[K] | BlockedReport | undefined>(`/api/dashboard/reports/${kind}?dateFrom=${encodeURIComponent(range.dateFrom)}&dateTo=${encodeURIComponent(range.dateTo)}`);
